<template>
  <div>
    <el-button type="primary" v-if="$route.name!='SupplierProduct'" size="small" class="btn primary" style="margin-right: 10px;" @click="batchApprovalEvt">批量审批</el-button>
    <el-dialog v-loading="loading"  title="批量审批" :visible.sync="dialogVisible" width="30%" :show-close="false" :before-close="closeEvt">
      <div>
        <div class="titleBox">
          <i class="el-icon-warning" style="color: orange;"></i>
            <span>您正在为{{ multipleSelectionList.length }}条单据做批量审批，请谨慎操作。</span>
        </div>
        <el-form ref="form" :model="form" :rules="rules" label-width="110px">
          <el-form-item label="审批结果:" prop="result">
            <el-radio-group v-model="form.result" @input="resultEvt">
              <el-radio :label="0">同意</el-radio>
              <el-radio :label="1">拒绝</el-radio>
            </el-radio-group>
          </el-form-item>
     
          
          <el-form-item label="审批意见:" :prop="approveRemarkName">
            <el-input type="textarea" v-model="form.approveRemark"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeEvt">取 消</el-button>
        <el-button type="primary" @click="approveEvt">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import {

  UpdateStockType,
  isUpdateProductOptions,
} from "@/enum";
export default {
  props:['multipleSelectionList','batchApproval'],
  mixins: [ GetDataMixin],
  data () {
    return {
      UpdateStockType:UpdateStockType,
      isUpdateProductOptions:isUpdateProductOptions,
      dialogVisible:false,
      form:{},
      submitList:[],
      rules:{
        result: [
            { required: true, message: '请选择审批结果', trigger: 'change' }
          ],
          approveRemark:[
            { required: true, message: '审批意见不能为空', trigger: 'blur' }
          ],
      },
      approveRemarkName:'approveRemark'
    }
  },
  methods: {
    batchApprovalEvt () {
        if(this.$route.name=='SupplierProductUpdate'){
          let show = false
          for (let index = 0; index <  this.multipleSelectionList.length; index++) {
            if(this.multipleSelectionList[index].state!=0){
              show = false
              this.$message({
                message: '所选数据存在不需要您审批的单据，请检查',
                type: 'warning'
              });
              return
              // break
            }else{
              show = true
            }
          }
          if(show){
             this.dialogVisible = true
          }

          this.dialogVisible = true
          return
        }
      
      if(this.multipleSelectionList.length==0){
        this.$message({
          message: '请勾选需要审批的数据！',
          type: 'warning'
        });
        return
      }
  
     
      let show = false
      for (let index = 0; index <  this.multipleSelectionList.length; index++) {
        if(this.multipleSelectionList[index].status!=1){
          show = false
          this.$message({
            message: '所选数据存在不需要您审批的单据，请检查',
            type: 'warning'
          });
          return
          // break
        }
           if(this.$route.name=='SupplierProductUpdate')return
        let ids = this.multipleSelectionList[index].approverIds.split(';')
        if(ids.some(v=>v==this.userInfo.id)){
          show = true
        }else{
          show = false
          this.$message({
            message: '所选数据存在不需要您审批的单据，请检查',
            type: 'warning'
          });
          return
          // break
        }
      }

      // if(this.$route.name == 'SupplierProduct'){
      //   let arr = this.multipleSelectionList.filter(res=>res.batchValidate ==0 || res.batchValidate ==null)
      //   if(arr.length){
      //     this.$message({
      //       message: `当前校验${arr.length}条未通过，请检查！`,
      //       type: 'warning'
      //     });
      //   return
      //   }
      // }

      if(show ){
       this.dialogVisible = true
      }
  
    },
    resultEvt(val){
      if(val == 1){
        this.approveRemarkName = 'approveRemark'
      }else{
         this.approveRemarkName = ''
         this.$refs.form.clearValidate();
      }
      
    },
    closeEvt(){
      this.form = {
        result:null,
        approveRemark:''
      }
      this.approveRemarkName = ''
      this.dialogVisible = false
    },
    approveEvt(){
      this.$refs.form.validate((valid) => {
        if(valid){
        this.loading = true
          this.form.ids =  this.multipleSelectionList.map(res=>res.id)
            this.batchApproval(this.form).then((res)=>{
              if(this.$route.name == 'SupplierProduct'){
                if(res.returnData.length){
                  this.$message({
                    message:res.returnData[0].errorMessage,
                    type: 'warning'
                  });
                }
          
              }
              this.loading = false
              this.$emit('getData');
              this.$emit('reset');
              this.closeEvt()
            }).catch(err=>{
              this.loading = false
            })
        }
      })
      
    }
  }
}
</script>

<style lang="scss" scoped>
.titleBox{
  text-align: center;
}
</style>